// extracted by mini-css-extract-plugin
export var deleteModal = "_rg-0";